import React from "react";
import { Container } from "react-bootstrap";
const HomeBanner = () => {
  const handleContextMenu = (e) => {
    e.preventDefault(); // Disable right-click context menu
  };
  const handleDragStart = (e) => {
    e.preventDefault(); // Disable drag-and-drop
  };
  return (
    <Container>
      <div className="home-banner">
        <div className="video-container">
          <video
            autoPlay
            muted
            loop
            onContextMenu={handleContextMenu} // Disable right-click
            onDragStart={handleDragStart} // Disable drag-and-drop
            preload="metadata"
          >
            <source
              src="https://dsider.co/static/media/company-intro.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="text-container">
          <p className="bannertext">
            Dsider democratizes analysis by integrating knowledge, economics,
            and efficient workflows, enabling users at all levels to make
            smarter, more collaborative decisions. Our AI-driven software powers
            real-time decision-making in the Energy sector, ensuring precision,
            efficiency, and lasting value from strategy to operations.{" "}
          </p>
        </div>
      </div>
    </Container>
  );
};

export default HomeBanner;
